// Inline SVG accents — cinematic gold/silver defaults.
import React from "react";

export const Star = ({ className = "", fill = "#C9A227", stroke = "#0A0A0B" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M50 4 L61 36 L96 37 L68 58 L78 92 L50 71 L22 92 L32 58 L4 37 L39 36 Z"
      fill={fill} stroke={stroke} strokeWidth="4" strokeLinejoin="round" />
  </svg>
);

export const Heart = ({ className = "", fill = "#151517", stroke = "#C9A227" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M50 88 C10 60 6 34 24 22 C38 13 50 26 50 32 C50 26 62 13 76 22 C94 34 90 60 50 88 Z"
      fill={fill} stroke={stroke} strokeWidth="4" strokeLinejoin="round" />
  </svg>
);

export const Crown = ({ className = "", fill = "none", stroke = "#C9A227" }) => (
  <svg viewBox="0 0 100 80" className={className} aria-hidden="true">
    <path d="M8 68 L16 24 L34 46 L50 14 L66 46 L84 24 L92 68 Z"
      fill={fill} stroke={stroke} strokeWidth="4" strokeLinejoin="round" />
    <rect x="8" y="72" width="84" height="3" fill={stroke} />
  </svg>
);

export const Scribble = ({ className = "", stroke = "#C9A227" }) => (
  <svg viewBox="0 0 200 40" className={className} aria-hidden="true" fill="none">
    <path d="M4 28 C40 6 60 34 96 14 C130 -4 150 30 196 10"
      stroke={stroke} strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const Spark = ({ className = "", fill = "#C9A227" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d="M50 0 C54 34 66 46 100 50 C66 54 54 66 50 100 C46 66 34 54 0 50 C34 46 46 34 50 0 Z" fill={fill} />
  </svg>
);

export const Arrow = ({ className = "", stroke = "#C9CCD3" }) => (
  <svg viewBox="0 0 120 60" className={className} aria-hidden="true" fill="none">
    <path d="M6 30 H104 M104 30 L82 10 M104 30 L82 50"
      stroke={stroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
